module.exports = __webpack_public_path__ + "media/images/urd_logo-2a9ef70a0fbc871cac81e02ffb0c69f3.png";